import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'uniqueCrsPnr'
})
export class UniqueCrsPnrPipe implements PipeTransform {

  transform(segments: any[]): string {
    if (!segments || !segments.length) return '';

    // Collect all crs_pnr values
    const allPnrs: string[] = [];

    segments.forEach(segment => {
      segment?.passengers?.forEach((p: any) => {
        if (p?.crs_pnr) {
          allPnrs.push(p.crs_pnr);
        }
      });
    });

    // Create a Set to get unique PNRs
    const uniquePnrs = [...new Set(allPnrs)];

    // Join them using `/`
    return uniquePnrs.join(' / ');
  }

}
